import { validateWagonMaintenanceByRakeName } from "..";
import axiosHttpRequest from "../axios";

//Get Customers
async function listCustomers(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}
//Get OD List
async function listOrignDestinations(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}
//Get GPWIS Status List
async function listGpwisStatus(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}
//Get SFTO Status List

//Get Active Rakes List
async function listSftoActiveRakes(endpoint, queryParams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryParams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function rakeWagonListService(endpoint, queryParams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryParams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function activeJobsListService(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function listGpwisActiveRakes(endpoint, queryParams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryParams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

//Commodity Master
async function listCommodity(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function sendEmailService(
  endpoint,
  queryParams,
  postdata,
  configheaders
) {
  queryParams.user_id = "usr_1";
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    queryParams,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function saveWagonMasterService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function saveVendorMasterService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function saveRakeMasterService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}
// async function saveWagonMasterService(
//   endpoint,
//   postdata,
//   configheaders
// ) {
//   const serviceResponse = await axiosHttpRequest.execPostRequest(
//     endpoint,
//     postdata,
//     configheaders
//   );
//   return serviceResponse;
// }

async function wagonMasterlistService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function wagonMasterByRakeNameService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getContractDetailsService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}
async function getVendorDetailsService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getContractStationsDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function searchMasterslistService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function
  searchVendorMasterlistService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function searchMastersFilterService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log('-----------sers---------', serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};

  if (serviceData.issuccess) {
    listViewData = serviceData;
  }
  // console.log('-----------sers---------', listViewData);
  listViewInfo.customerName = serviceData.customerList;
  listViewInfo.rakeName = serviceData.rakeList;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}
async function searchVendorMastersFilterService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log('-----------sers---------', serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}
async function generateLoadNoService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function deleteContractLineItemService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execDeleteRequestsWithParams(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getDashboardDataService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getDashboardStatusDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}


async function getCommodityMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getCommodityDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function saveCustomerThreshold(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function getCustomerThresholdDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getMaterialClassMasterList(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveMaterialClassMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getFrieghtsMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveFrieghtsMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getExaminationTypeMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveExaminationTypeMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getDepoMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveDepoMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getWagonComponentMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveWagonComponentMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getRohPohScheduleMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveRohPohScheduleMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getUniqueWagonTypeList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getRakeMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveRakeRebateMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getODMasterList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "OD Pair Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveODMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getTATReconciliationMasterTransactorList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "OD Pair Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveTATReconciliationMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getUserClientData(endpoint) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParamsForClientDetails(endpoint);
  return serviceResponse;
}

async function wagonComponentMasterExcelDownload(endpoint, filename, configheaders, postdata) {
  axiosHttpRequest.execGetRequestsWithParamsDownloadFile(endpoint, filename, configheaders, postdata)
}

async function getStationMaster(endpoint, queryParams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryParams,
    configheaders
  );
  const serviceResponseData = serviceResponse.data;
  if (serviceResponseData.issuccess && serviceResponseData.Records){
    return {
      records: serviceResponseData.Records,
      paginationInfo: serviceResponseData.paginationinfo
    }
  }
  return {};
}

async function createStationMaster(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function downloadStationMaster(endpoint, filename, configheaders, postdata) {
  axiosHttpRequest.execGetRequestsWithParamsDownloadFile(endpoint, filename, configheaders, postdata)
}

async function getWagonMaintenanceList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  // console.log(serviceResponse, "Material Response");
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

export default {
  listCustomers,
  listOrignDestinations,
  listGpwisStatus,
  listSftoActiveRakes,
  listGpwisActiveRakes,
  listCommodity,
  sendEmailService,
  activeJobsListService,
  rakeWagonListService,
  saveWagonMasterService,
  saveVendorMasterService,
  saveRakeMasterService,
  wagonMasterlistService,
  getContractDetailsService,
  getVendorDetailsService,
  getContractStationsDetailsService,
  searchMasterslistService,
  searchVendorMasterlistService,
  searchMastersFilterService,
  searchVendorMastersFilterService,
  generateLoadNoService,
  getContractStationsDetailsService,
  deleteContractLineItemService,
  getDashboardDataService,
  getDashboardStatusDetailsService,
  getCommodityMasterList,
  getCommodityDetails,
  saveCustomerThreshold,
  getCustomerThresholdDetails,
  getMaterialClassMasterList,
  saveMaterialClassMaster,
  getFrieghtsMasterList,
  saveFrieghtsMaster,
  getExaminationTypeMasterList,
  saveExaminationTypeMaster,
  getDepoMasterList,
  saveDepoMaster,
  getWagonComponentMasterList,
  saveWagonComponentMaster,
  getRohPohScheduleMasterList,
  saveRohPohScheduleMaster,
  getUniqueWagonTypeList,
  getRakeMasterList,
  saveRakeRebateMaster,
  getODMasterList,
  saveODMaster,
  getTATReconciliationMasterTransactorList,
  saveTATReconciliationMaster,
  getUserClientData,
  getStationMaster,
  createStationMaster,
  downloadStationMaster,
  wagonMasterByRakeNameService,
  getWagonMaintenanceList,
  validateWagonMaintenanceByRakeName,
  saveExaminationTypeMaster,
  getExaminationTypeMasterList,
  saveDepoMaster,
  getDepoMasterList,
  saveWagonComponentMaster,
  getWagonComponentMasterList,
  getRohPohScheduleMasterList,
  saveRohPohScheduleMaster,
  getUniqueWagonTypeList,
  wagonComponentMasterExcelDownload,
  wagonMasterByRakeNameService
};
